/**
 * ч.740 (рішення власника): «створити на підставі» для документів Покупок —
 * платіжка (банк) і касовий ордер з «ще дії» редактора документа.
 * Редактори BankDocEditor / CashDocEditor читають ці query-параметри на new.
 */
import type { NavigateFunction } from 'react-router-dom';
import type { ExtraAction } from '@/shared/components/DocumentToolbar';

export interface PaymentPrefill {
  org?: string | null;
  contractor?: string | null;
  contract?: string | null;
  amount?: number | string | null;
  purpose?: string | null;
  order?: string | null;      // supplier/customer order (deal)
  project?: string | null;
  op?: string | null;         // operation_type
  corr?: string | null;       // кореспондуючий рахунок (override)
}

export function prefillQuery(p: PaymentPrefill): string {
  const q = new URLSearchParams();
  const put = (k: string, v: unknown) => {
    if (v === undefined || v === null || v === '') return;
    q.set(k, String(v));
  };
  put('org', p.org); put('contractor', p.contractor); put('contract', p.contract);
  put('amount', typeof p.amount === 'number' ? p.amount.toFixed(2) : p.amount);
  put('purpose', p.purpose); put('order', p.order); put('project', p.project);
  put('op', p.op); put('corr', p.corr);
  return q.toString();
}

export const fmtDocDate = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString('uk-UA') : '';

export const vatTail = (vat: number) =>
  vat > 0 ? `, у т.ч. ПДВ ${vat.toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} грн` : ', без ПДВ';

/**
 * Дві дії для «ще дії»: платіжка (банк) + касовий ордер. direction 'out' —
 * оплата постачальнику (списання + РКО), 'in' — надходження (напр. повернення
 * коштів від постачальника: надходження + ПКО). До збереження — disabled.
 */
export function moneyDocActions(opts: {
  navigate: NavigateFunction; isNew: boolean; direction: 'out' | 'in'; prefill: PaymentPrefill;
}): ExtraAction[] {
  const { navigate, isNew, direction, prefill } = opts;
  const q = prefillQuery(prefill);
  const disabled = isNew || !prefill.contractor;
  const title = isNew ? 'Спершу збережіть документ'
    : !prefill.contractor ? 'У документі не вказано контрагента' : undefined;
  if (direction === 'out') {
    return [
      { label: 'створити платіжку (банк)', disabled,
        title: title ?? 'Списання з рахунку постачальнику на суму документа — збережеться чернеткою у «Банк → Списання → збережені»',
        onClick: () => navigate(`/bank-payments/new?${q}`) },
      { label: 'створити касовий ордер (РКО)', disabled,
        title: title ?? 'Видатковий касовий ордер постачальнику на суму документа',
        onClick: () => navigate(`/cash-payments/new?${q}`) },
    ];
  }
  return [
    { label: 'створити надходження (банк)', disabled,
      title: title ?? 'Надходження коштів від постачальника на суму документа',
      onClick: () => navigate(`/bank-receipts/new?${q}`) },
    { label: 'створити касовий ордер (ПКО)', disabled,
      title: title ?? 'Прибутковий касовий ордер від постачальника на суму документа',
      onClick: () => navigate(`/cash-receipts/new?${q}`) },
  ];
}
